module.exports = __webpack_public_path__ + "img/interexpress_charge_logo.920a4a09.png";